
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from '@/contexts/AuthContext'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from '@/components/ui/sonner'

// Clear any stored session/auth data on app start (optional - remove if causing issues)
// localStorage.removeItem('supabase.auth.token');
// sessionStorage.removeItem('supabase.auth.token');

// Add a console log to help debug which provider is being used
console.log("Using AuthProvider from @/contexts/AuthContext");

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <AuthProvider>
      <App />
      <Toaster position="top-right" />
    </AuthProvider>
  </HelmetProvider>
);
